import {Box, Stack, Paper, Typography } from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useState, useEffect } from 'react';
import AnaliticsBilling from "../AnaliticsBilling/AnaliticsBilling"


const AnaliticsBillings = ({ billings, timeStart, timeEnd, sx }) => {

    const [value, setValue] = useState(billings[0].billing_id);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Paper sx={{ ...sx }}>
            <Stack p={2}>
                <Typography variant="h3">Billings</Typography>
                <Stack 
                    direction="row"
                    spacing={{ xs: 1, sm: 2 }}
                    useFlexGap
                    sx={{ flexWrap: 'wrap'}}
                >
                    {billings.length > 1 && (
                        <Box width={"100%"} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                {billings.map((billing) => {
                                    return <Tab value={ billing.billing_id } label={billing.description} wrapped/>
                                })}
                            </Tabs>
                        </Box>
                    )}
                    {value && billings &&
                        <Paper sx={{width: '100%'}}>
                            <AnaliticsBilling
                                billing={billings.find(billing => billing.billing_id === value)}
                                timeStart={timeStart}
                                timeEnd={timeEnd}
                            />
                        </Paper>
                    }
                </Stack>
            </Stack>
        </Paper>
    )};

export default AnaliticsBillings;